<template>
  <div class="page-shell">
    <p class="mobile-page-title font-helvetica-700 font-bold text-gray-dark lg:text-[40px] lg:uppercase">Заказы</p>
    <OrdersNavBar />

    <div class="flex flex-col gap-4">
      <OrdersDateFilter v-model:model-value="dateRange" @show="fetchHistory" />

      <OrdersTable :orders="orders" :loading="loading" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import OrdersNavBar from "~/components/orders/OrdersNavBar.vue";
import OrdersDateFilter from "~/components/orders/OrdersDateFilter.vue";
import OrdersTable from "~/components/orders/OrdersTable.vue";
import { useNuxtApp } from "#imports";

usePageTitle("История заказов");

const dateRange = ref<{ from: string | null; to: string | null }>({ from: null, to: null });
const orders = ref<{
  code: string;
  date: string;
  status: string;
  sum: string;
  organization: string;
  contractor: string;
  guid?: string;
}[]>([]);
const loading = ref(false);

const nuxtApp = useNuxtApp();
const $useOneCApi = nuxtApp.$useOneCApi as (action: string, payload?: Record<string, any>) => Promise<any>;

const ensureDate = (value: string | null, fallback: Date) => {
  const d = value ? new Date(value) : fallback;
  return isNaN(d.getTime()) ? fallback : d;
};

const buildPayload = () => {
  const defaultFrom = new Date(2022, 0, 1);
  const defaultTo = new Date();
  const fromDate = ensureDate(dateRange.value.from, defaultFrom);
  const toDate = ensureDate(dateRange.value.to, defaultTo);
  return {
    from_day: String(fromDate.getDate()),
    from_month: String(fromDate.getMonth() + 1),
    from_year: String(fromDate.getFullYear()),
    to_day: String(toDate.getDate()),
    to_month: String(toDate.getMonth() + 1),
    to_year: String(toDate.getFullYear()),
  };
};

const fetchHistory = async () => {
  loading.value = true;
  try {
    const res = await $useOneCApi("getOrderHistory", buildPayload());
    const list = Array.isArray(res?.["Заказы"]) ? res["Заказы"] : [];
    orders.value = list.map((item: any) => ({
      code: String(item?.Номер ?? "—"),
      date: String(item?.Дата ?? ""),
      status: String(item?.Состояние ?? ""),
      sum: String(item?.Сумма ?? ""),
      organization: String(item?.Организация ?? ""),
      contractor: String(item?.Контрагент ?? ""),
      guid: item?.guid ? String(item.guid) : undefined,
    }));
  } catch (error) {
    console.error("Не удалось загрузить историю заказов", error);
    orders.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(fetchHistory);
</script>
